import postWithToken from './base/post-with-token'

const archiveAlertApi = (id) => postWithToken(`/alerts/${id}/archive`)()

export default archiveAlertApi
